import development from '../config/development.config';
import staging from '../config/staging.config';
import production from '../config/production.config';
import local from '../config/local.config';

export default {
    common: {
        bugsnagApiKey: '08ee16c8feb3e7182c4c9842d4d5dd50',
    },
    development,
    staging,
    production,
    local,
};
